export const FETCH_DEPARTMENT_REQUEST = "FETCH_DEPARTMENT_REQUEST";

export const EDIT_DEPARTMENT_REQUEST_INFO = "EDIT_DEPARTMENT_REQUEST_INFO";

export const MARGE_DEPARTMENT_REQUESTS = "MARGE_DEPARTMENT_REQUESTS";


